import { useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  paypal_destination_email: "marketlineplus56@gmail.com",
  support_email: "contact@swiftlink-africa.com",
  hero_title: "",
  hero_subtitle: "",
  hero_image_url: "",
  fr_ga_intro: "",
  trust_title: "",
  trust_body: "",
  faq_intro: "",
  footer_tagline: "",
};

/**
 * Lightweight cache-then-fetch hook for the admin-editable site content.
 * Falls back to empty strings (caller decides on its own defaults).
 */
export function useSiteContent() {
  const [content, setContent] = useState(() => {
    try {
      const raw = sessionStorage.getItem("sl_site_content");
      return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : DEFAULTS;
    } catch (_e) {
      return DEFAULTS;
    }
  });

  useEffect(() => {
    let cancelled = false;
    api
      .get("/site-content")
      .then(({ data }) => {
        if (cancelled) return;
        setContent({ ...DEFAULTS, ...(data || {}) });
        try { sessionStorage.setItem("sl_site_content", JSON.stringify(data || {})); } catch (_e) { /* ignore */ }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return content;
}
